import { chakra } from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../components/modal-wrapper';

export const NotificationModalWrapper = chakra(ModalWrapper, {
    label: 'NotificationModalWrapper',
    baseStyle: {
        flexDirection: 'column',
        ['h3']: {
            fontSize: '18px',
            mb: '10px',
            mt: '10px'
        },
        ['p']: { fontSize: '16px' }
    }
});
